import notification from 'antd/lib/notification';
export var checkPermissionForOnClick = function (hasPermission, message) {
    if (!hasPermission) {
        notification.error({ message: "".concat(message, " \uAD00\uB9AC\uC790\uACC4\uC815\uC744 \uD1B5\uD574 \uAD8C\uD55C\uC744 \uD5C8\uC6A9\uD574\uC8FC\uC138\uC694.") });
    }
    return hasPermission;
};
export var AntNotification = notification;
